export const el = <T extends HTMLElement = HTMLElement>(
    tagName: string,
    options: { [key: string]: string | boolean } = {}
): T => {
    const element = document.createElement(tagName);

    Object.entries(options).forEach(([key, value]) => {
        if (key === 'text') {
            element.textContent = value as string;
        } else if (key === 'html') {
            element.innerHTML = value as string;
        } else if (typeof value === 'boolean') {
            if (value) element.setAttribute(key, '');
        } else {
            element.setAttribute(key, value as string);
        }
    });

    return element as T;
};

export const removeAttributes = (element: Element, attributes: string[]): void => {
    attributes.forEach(attr => element.removeAttribute(attr));
};

export function debounce<T extends (...args: any[]) => void>(
    func: T,
    wait: number = 250
): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout> | null;

    return function (...args: Parameters<T>) {
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            func(...args);
        }, wait);
    };
}


export const throttle = <T extends (...args: any[]) => void>(
    func: T,
    limit: number = 250
): ((...args: Parameters<T>) => void) => {
    let lastCall = 0;

    return (...args: Parameters<T>) => {
        const now = Date.now();

        if (now - lastCall >= limit) {
            lastCall = now;
            func(...args);
        }
    };
};
